export const parseISOStringDate = (date: string | undefined | null) => {
  if (!date) return undefined
  const [year, month, day] = date.split(`-`).map(Number)
  if (!day) {
    return new Date(month === 12 ? year + 1 : year, month === 12 ? 0 : month, 0) // Last day of the month
  }
  return new Date(year, month - 1, day)
}

export const formatDateWithoutTime = (date: Date | undefined) => {
  if (!date) return undefined
  date.setTime(date.getTime() - date.getTimezoneOffset() * 60000)
  const dateAsString = date.toISOString().split(`T`)[0]
  return dateAsString
}

export const splitPeriod = (period: string) => {
  const [year, month] = period.split(`-`)
  return { year, month }
}

export const getPeriodDate = (period: string) => {
  const { year, month } = splitPeriod(period)
  return new Date(parseInt(year, 10), parseInt(month, 10) - 1)
}

export const formatPeriod = (period: string): string => {
  const periodDate = getPeriodDate(period)
  return (
    periodDate.toLocaleString(`en-US`, { month: `short` }) +
    periodDate.getFullYear().toString().slice(2)
  )
}

export const dateWithoutTimeZone = (date: Date | undefined | string) => {
  if (!date) return undefined
  const dateObj = typeof date === `string` ? new Date(date) : date
  dateObj.setTime(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000)
  return dateObj
}

export const formatDate = (date: Date | undefined | string) => {
  if (!date) return undefined
  let dateObj = date
  if (typeof date === `string`) {
    dateObj = new Date(date)
  }
  if (dateObj instanceof Date) {
    const dateWithoutTime = dateWithoutTimeZone(dateObj)
    return Intl.DateTimeFormat(`it-IT`, {
      year: `numeric`,
      month: `2-digit`,
      day: `2-digit`,
      hour: `numeric`,
      minute: `numeric`,
      hour12: true,
    }).format(dateWithoutTime)
  }
  return undefined
}

export const getMonthAndYearFromDate = (date: Date) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1 // Convert to 1-based month
  return {
    month,
    year,
  }
}
